var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/034cdb56e04d5e2c3c963c358e85ee84.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/03e4902bbd8dfbf450c1334e83beef48.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a68da52cf7d005d0b9255fb6f572798.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1896b933a34b546fbbdd2ba98b655f5a.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33afa0d4b059d2e4c257b439e7232722.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4735d9fa20759d5edb722d2cb5677b5b.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5a9b69de574dc0d8c04cacc07b785a06.js').default;
var scope_8 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/76524342ba8004d5f5abbc4474e79a42.js').default;
var scope_9 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/866665cf6ee59467a4f9cc7d1bdb0e61.js').default;
var scope_10 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a217b64c022ed3b031baaedd900293f7.js').default;
var scope_11 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a61ff2e60d4a354dee7306f075745a79.js').default;
var scope_12 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c8900e7254ba9fa19f93c2ecc3988ee7.js').default;
var scope_13 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f77cefb2bd9ea9f32ac054fdcc7115da.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    